import { createContext, useState } from 'react'
import { IFiltersSelected } from '../shared/components/Filters/Filters.model'
import { useTranslation } from 'react-i18next'
import { IProyectos } from '../shared/data/data.model'

const initialValue: any = {}

const FiltersContext = createContext<any>(initialValue)

export const FiltersProvider = ({ children }: any) => {
  const { t }: any = useTranslation()
  const [filterOpen, setFilterOpen] = useState('')

  const filterCategories = [
    { name: t('filters.categories.pais'), filterKey: 'id_pais' },
    { name: t('filters.categories.departamento'), filterKey: 'departamento' },
    {
      name: t('filters.categories.tipo_territorio'),
      filterKey: 'id_tipo_territorio',
    },
    { name: t('filters.categories.bioma'), filterKey: 'id_bioma' },
    // { name: t('filters.categories.amazonia'), filterKey: 'amazonia' },
    {
      name: t('filters.categories.desarrolladora'),
      filterKey: 'empresas_desarrolladoras',
    },
    { name: t('filters.categories.auditor'), filterKey: 'verificador' },
    {
      name: t('filters.categories.certificador'),
      filterKey: 'estandar_certificacion',
    },
  ]

  const [filtersSelected, setFiltersSelected] = useState<IFiltersSelected>({
    id_pais: [
      { label: t('countries.brasil'), value: 'brasil' },
      { label: t('countries.colombia'), value: 'colombia' },
      { label: t('countries.peru'), value: 'peru' },
    ],
    departamento: [{ label: t('filters.all'), value: t('filters.all') }],
    id_territorio: [{ label: t('filters.all'), value: t('filters.all') }],
    bioma: [{ label: t('filters.all'), value: t('filters.all') }],
    amazonia: [{ label: t('filters.all'), value: t('filters.all') }],
    auditor: [{ label: t('filters.all'), value: t('filters.all') }],
    certificador: [{ label: t('filters.all'), value: t('filters.all') }],
    desarrolladora: [{ label: t('filters.all'), value: t('filters.all') }],
  })

  const [projectSelected, setProjectSelected] = useState<IProyectos>()

  return (
    <FiltersContext.Provider
      value={{
        filterCategories,
        filtersSelected,
        setFiltersSelected,
        projectSelected,
        setProjectSelected,
        filterOpen,
        setFilterOpen,
      }}
    >
      {children}
    </FiltersContext.Provider>
  )
}

export default FiltersContext
